<template>
    <div class="message-thread">

        <div class="message-thread-header">
            <div class="title">{{ message.sender.name }}</div>
            <div class="description">{{ message.subject }}</div>
        </div>

        <spinner v-if="loading === true" class="spinner"></spinner>
        <div v-else="" class="message-thread-group" v-for="(group, date) in groupedMessages">
            <div class="message-thread-group-header">{{ $moment(date, 'YYYY-MM-DD', true).format('dddd, DD. MMMM, YYYY') }}</div>

            <div class="message-thread-group-item message-item" v-for="m in group">
                <avatar :avatar="m.sender.avatar" class="avatar"></avatar>
                <div class="title">{{ m.sender.name }}</div>
                <div class="description">{{ m.message }}</div>
            </div>
        </div>

        <div>
            <form class="message-form" @submit.prevent="send()">
                <label for="message" class="show-for-sr">Ziņojums</label>
                <textarea id="message" name="message" v-model="response" rows="4"></textarea>
                <button type="submit" class="button success" :disabled="response === ''">Sūtīt</button>
            </form>
        </div>

    </div>
</template>

<script>
    import Avatar from '../../components/Avatar'
    import messages from '../../api/messages'
    import { mapGetters } from 'vuex'

    export default {
        name: 'message-thread',

        props: {
            'message': {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                thread: null,
                response: null,
                loading: false,
            }
        },

        computed: {

            ...mapGetters(['user']),

            flatMessageThread() {
                const replies = this.thread.replies == null ? [] : this.thread.replies;
                return this.thread ? [this.thread].concat(replies) : []
            },

            groupedMessages() {
                const group = {}

                this.flatMessageThread.forEach((m) => {
                    const key = this.$moment(m.created_at).format('YYYY-MM-DD')
                    group[key] = group[key] || []
                    group[key].push(m)
                })

                return group;
            }
        },

        methods: {
            send() {
                this.loading = true
                messages.send({
                    message: this.response,
                    reply_to_id: this.message.id,
                    recipient_id: this.message.recipient_id === this.user.id ? this.message.sender_id : this.message.recipient_id,
                    subject: this.message.subject,
                }).then(response => {
                    this.loadThread()
                        .then(response => this.loading = false);
                    this.response = null;
                })
            },

            loadThread() {
                this.loading = true;
                console.log('load thread');
                return messages.find(this.message.id)
                    .then(response => {
                        console.log('found messages in thread', response);
                        this.thread = response.data.data
                        this.$emit('loaded', this.message)
                        this.loading = false;

                        return response;
                    })
            }
        },

        created() {
            if (this.message) {
                this.loadThread()
            }
        },

        watch: {
            'message': function (val, oldVal) {
                this.thread = null
                this.loadThread()
            }
        },

        components: {
            Avatar
        }

    }
</script>

<style scoped lang="scss">
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    $border-color: #e8e8e8;
    $message-item-padding: 20px;

    .message-thread {

        .message-thread-header {
            padding: px-em($message-item-padding);

            .title {
                font-weight: bold;
            }
            .description {
                color: #a6b4c0;
            }
        }

        .message-item {
            @include clearfix;

            padding: px-em($message-item-padding) px-em($message-item-padding) px-em($message-item-padding) px-em($message-item-padding + 48px + 16px);
            border-bottom: none;
            position: relative;
            min-height: 48px + $message-item-padding * 2;

            .title {
                font-weight: bold;
            }

            .avatar {
                width: px-em(48px);
                height: px-em(48px);
                left: px-em($message-item-padding);
                top: px-em($message-item-padding);
                position: absolute;
                margin-right: 1em;
            }

            .time {
                color: #a6b4c0;
            }

            .description {
                color: $body-color;
                white-space: pre-wrap;
            }
        }

        .message-thread-group {
            margin-top: -1px;
            border-top: 1px solid $border-color;
            border-bottom: 1px solid $border-color;

            &:last-child {
                 margin-bottom: -1px;
             }

            .message-thread-group-header {
                margin-top: -1px;
                border-top: 1px solid $border-color;
                border-bottom: 1px solid $border-color;
                color: #a6b4c0;
                font-size: px-em(14px);
                padding: 0.5em 1em ;
                background-color: $white;
            }
        }
    }

    .message-form {
        display: flex;
        align-items: flex-end;
        padding: px-em(20px);

        textarea {
            margin-right: 1em;
        }

        input,
        button,
        textarea {
            margin-bottom: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/inbox/MessageThread.vue